import React, { useState, useEffect, useContext } from 'react';
import Typography from '@mui/material/Typography';
import { MsalContext } from '../Contexts/MsalContext';

export default function VersionDisplay() {
    const { msalFetch } = useContext(MsalContext);
    const [version, setVersion] = useState('test');

    useEffect(() => {
        msalFetch('api/Home/GetVersion')
            .then(response => response.text())
            .then(data => {
                setVersion(data);
            });
    }, []);

    return (
        <div>
            <Typography variant="body2" align="right" style={{ color: "var(--light-text)" }}>{version}</Typography>
        </div>
    );
}